module.exports = __webpack_public_path__ + "img/avatar.2ac1adea.png";